import React from 'react';
import { Link } from 'react-router-dom';
import './Auth.css';

const Unauthorized = () => {
    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Access Denied</h2>
                <p>You are not authorized to access this page.</p>
                <div style={{ marginTop: '16px' }}>
                    <Link to="/dashboard">Go to Dashboard</Link>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;
